import { Injectable } from '@angular/core';
import { ApiService } from '../api/api.service';
import { HelpResponse } from 'src/app/models/Help/HelpResponse.model';
import { HelpLayoutEnum } from 'src/app/Enums/HelpLayoutEnum';
import { HelpContentTypeEnum } from 'src/app/Enums/HelpContentTypeEnum';
import { AppConfigService } from '../app-config/app-config.service';

@Injectable({
  providedIn: 'root'
})
export class HelpService {

  constructor(
    private api: ApiService,
    private appConfig: AppConfigService
  ) {

  }
  //Guarda o Id do Modal para ser fechado após ser clicado em outro
  previousHelpId = 0;

  public async getHelpPageFullPath(helpId: number): Promise<string> {
    try {
      const response = await this.api.get<HelpResponse>("/v1/help", { helpId: helpId });

      if (response.success && response.data) {
        const helpData = response.data;

        const webLayout = helpData.layouts?.find(l => l.layout === HelpLayoutEnum.web);
        if (webLayout) {
          const htmlContent = webLayout.contents?.find(c => c.contentType === HelpContentTypeEnum.Html);
          if (htmlContent && htmlContent.url) {
            return htmlContent.url;
          }
        }
      }
    } catch (err) {
      // Retorna fallback em caso de erro
    }
    return this.appConfig.helpFallbackUrl;
  }

  public async postClickedHelp(helpId: number): Promise<void> {
    try {
      await this.api.post<any>('/v1/help/access', { HelpId: helpId });
    } catch (err) {
      throw (err)
    }
  }
}
